/** Shared table presentation only; domain records and query values are never translated. */
export const smartTableTranslations = {
  fr: {
    'up': 'croissant',
    'down': 'décroissant',
    'Work status': 'Statut de travail',
    'Mode and location': 'Mode et lieu',
    'Requirements': 'Exigences',
    'Sort by': 'Trier par',
    'Sort direction': 'Sens du tri',
    'Ascending': 'Croissant',
    'Descending': 'Décroissant',
    'Clear sorting': 'Effacer le tri',
    'Sorted by {column}, {direction}': 'Tri par {column}, {direction}',
    'Clear sorting restores the default order.': 'Effacer le tri rétablit l’ordre par défaut.',
    'Page filters refine only the current page.': 'Les filtres de page affinent uniquement la page actuelle.',
    'Job filters': 'Filtres des missions',
    'Jobs table': 'Tableau des missions',
    'Active filters': 'Filtres actifs',
    'Clear all': 'Tout effacer',
    'Advanced': 'Avancé',
    '{count} results': '{count} résultats',
    'Role / skill': 'Rôle / compétence',
    'Created': 'Création',
  },
  ar: {
    'up': 'تصاعدي',
    'down': 'تنازلي',
    'Work status': 'حالة العمل',
    'Mode and location': 'النمط والموقع',
    'Requirements': 'المتطلبات',
    'Sort by': 'ترتيب حسب',
    'Sort direction': 'اتجاه الترتيب',
    'Ascending': 'تصاعدي',
    'Descending': 'تنازلي',
    'Clear sorting': 'مسح الترتيب',
    'Sorted by {column}, {direction}': 'مرتب حسب {column}، {direction}',
    'Clear sorting restores the default order.': 'مسح الترتيب يعيد الترتيب الافتراضي.',
    'Page filters refine only the current page.': 'مرشحات الصفحة تنقح الصفحة الحالية فقط.',
    'Job filters': 'مرشحات الوظائف',
    'Jobs table': 'جدول الوظائف',
    'Active filters': 'المرشحات النشطة',
    'Clear all': 'مسح الكل',
    'Advanced': 'متقدم',
    '{count} results': '{count} نتيجة',
    'Role / skill': 'الدور / المهارة',
    'Created': 'الإنشاء',
  },
  tr: {
    'up': 'artan',
    'down': 'azalan',
    'Work status': 'Çalışma durumu',
    'Mode and location': 'Çalışma biçimi ve konum',
    'Requirements': 'Gereksinimler',
    'Sort by': 'Sıralama ölçütü',
    'Sort direction': 'Sıralama yönü',
    'Ascending': 'Artan',
    'Descending': 'Azalan',
    'Clear sorting': 'Sıralamayı temizle',
    'Sorted by {column}, {direction}': '{column} ile sıralandı, {direction}',
    'Clear sorting restores the default order.': 'Sıralamayı temizlemek varsayılan sırayı geri yükler.',
    'Page filters refine only the current page.': 'Sayfa filtreleri yalnızca geçerli sayfayı daraltır.',
    'Job filters': 'İş filtreleri',
    'Jobs table': 'İş tablosu',
    'Active filters': 'Etkin filtreler',
    'Clear all': 'Tümünü temizle',
    'Advanced': 'Gelişmiş',
    '{count} results': '{count} sonuç',
    'Role / skill': 'Rol / beceri',
    'Created': 'Oluşturulma',
  },
}
